import React, { useState } from "react";
import { useCart } from "./cartcontext.jsx";
import "./cart.css";
import { useNavigate } from "react-router-dom";

function ProductCart() {
  const { cart, removeFromCart, updateQuantity, clearCart } = useCart();
  const [showform, setform] = useState(false);
  const navigate = useNavigate();

  const [formdata, setformdata] = useState({
    firstname: "",
    lastname: "",
    emailaddress: "",
    phonenumber: "",
    productinterested: "",
    projectdetails: "",
  });

  const handleonchange = (e) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleshowform = () => {
    setform(true);
  };

  const handleformsubmit = (e) => {
  e.preventDefault();

  const {
    firstname,
    lastname,
    emailaddress,
    phonenumber,
    productinterested,
    projectdetails,
  } = formdata;

  // FIRST NAME VALIDATION
  if (!firstname.trim()) {
    alert("Please enter your first name.");
    return;
  }

  // LAST NAME VALIDATION
  if (!lastname.trim()) {
    alert("Please enter your last name.");
    return;
  }

  // EMAIL VALIDATION
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(emailaddress)) {
    alert("Please enter a valid email address.");
    return;
  }

  // PHONE VALIDATION (10 digits only)
  const phoneDigits = phonenumber.replace(/\D/g, "");
  if (phoneDigits.length !== 10) {
    alert("Phone number must be exactly 10 digits.");
    return;
  }

  // PRODUCT INTEREST VALIDATION
  if (!productinterested) {
    alert("Please select a product interest.");
    return;
  }

  let totalItems = 0;
  let productsText = "";

  cart.forEach((item, index) => {
    const qty = item.quantity || 1;
    totalItems += qty;

    productsText +=
      `${index + 1}. ${item.name}\n` +
      `Category: ${item.categoryName}\n` +
      `Quantity: ${qty}\n` +
      `Price Range: ${item.priceRange}\n\n`;
  });

  if (cart.length === 0) {
    productsText = "No products selected.\n";
  }

  const message = `
*WIP ALUMINIUM*
Premium Aluminium Windows & Doors

📞 Phone: 072 696 5644
📧 Email: ipfieisrael@gmail.com

-------------------------------------

*QUOTE REQUEST*

*Customer Details*
Name: ${firstname} ${lastname}
Email: ${emailaddress}
Phone: ${phonenumber}

-------------------------------------

*Products*

${productsText}

-------------------------------------

*Total Items:* ${totalItems}

-------------------------------------

*Project Details*
${projectdetails}

Thank you for choosing *WIP Aluminium*
`;

  const phone = "27726965644";

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappUrl, "_blank");

  clearCart();
  navigate("/");
};

  return (
    <div className="cart-page-wrapper">
      <div className="breadcrumb">Home {'>'} Cart</div>
      <h1 className="page-heading">YOUR CART</h1>

      <div className="cart-content-wrapper">
        <div className="cart-items-list">
          {cart.length === 0 ? (
            <div className="empty-cart">Your quote request cart is empty</div>
          ) : (
            cart.map((item) => (
              <div className="cart-item" key={item.id}>
                <div className="item-image-wrapper">
                  <img src={item.mainImageUrl} alt={item.name} />
                </div>

                <div className="item-details">
                  <p className="item-name">{item.name}</p>
                  <p className="item-meta">
                    Category: {item.categoryName}
                  </p>
                  <p className="item-meta">
                    Price Range: {item.priceRange}
                  </p>
                </div>

                <div className="item-actions">
                  <button
                    className="remove-item-btn"
                    onClick={() => removeFromCart(item.id)}
                  >
                    🗑️
                  </button>

                  <div className="quantity-control">
                    <button
                      className="qty-btn"
                      onClick={() => updateQuantity(item.id, -1)}
                    >
                      -
                    </button>

                    <span>{item.quantity || 1}</span>

                    <button
                      className="qty-btn"
                      onClick={() => updateQuantity(item.id, 1)}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="order-summary-card">
          <h2 className="summary-title">Quote Request Summary</h2>

          <div className="summary-line">
            <span>Items in Cart</span>
            <span>{cart.length}</span>
          </div>

          <div className="summary-line total-line">
            <span>Total Items for Quote</span>
            <span>
              {cart.reduce((sum, item) => sum + (item.quantity || 1), 0)}
            </span>
          </div>

          {!showform && (
            <button className="checkout-btn" onClick={handleshowform}>
              Get a Quote →
            </button>
          )}

          {showform && (
            <div className="quote-form-section">
              <h3>Request Your Quote</h3>

              <label>First Name</label>
              <input
                name="firstname"
                placeholder="Ipfi"
                onChange={handleonchange}
                value={formdata.firstname}
              />

              <label>Last Name</label>
              <input
                name="lastname"
                placeholder="Ndou"
                onChange={handleonchange}
                value={formdata.lastname}
              />

              <label>Email Address</label>
              <input
                name="emailaddress"
                type="email"
                placeholder="ipfieisrael@gmail.com"
                onChange={handleonchange}
                value={formdata.emailaddress}
              />

              <label>Phone Number</label>
              <input
                name="phonenumber"
                placeholder="0713618793"
                onChange={handleonchange}
                value={formdata.phonenumber}
              />

              <label>Product Interest</label>
              <select
                name="productinterested"
                onChange={handleonchange}
                value={formdata.productinterested}
              >
                <option value="">Select an option</option>
                <option value="Windows">Windows</option>
                <option value="Doors">Doors</option>
                <option value="Gates">Gates</option>
                <option value="Multiple">Multiple</option>
              </select>

              <label>Project Details</label>
              <textarea
                name="projectdetails"
                placeholder="Tell us about your project requirements..."
                onChange={handleonchange}
                value={formdata.projectdetails}
              />

              <button
                onClick={handleformsubmit}
                className="submit-btn-form"
              >
                Submit Quote Request →
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCart;